module.exports = __webpack_public_path__ + "img/ic_favorited_sparks.6a25e74f.png";